import { createStyles, makeStyles, Theme, Grid } from '@material-ui/core';

import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { baseTheme } from '../../theme';
import LogInForm from '../login-form';
import UserDetailsForm from '../user-details-form';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginContainer: {
      fontSize: '1em',
      justifyContent: 'flex-end',
    },
  }),
);

export default function UserChip(props: any) {
  const classes = useStyles(baseTheme);
  const auth = useSelector((state: any) => state.auth);
  const profile = useSelector((state: any) => state.user.profile);

  return (
    auth.authenticated && profile ?
      <Grid container item xs={6} className={classes.loginContainer}>
        <UserDetailsForm currUser={profile} />
      </Grid>
      :
      <Grid container item xs={6} className={classes.loginContainer}>
        <LogInForm />
      </Grid>
  );
}
